export default {
  // FIXME: Check those strings
  ROLE_GENERIC: [
    {
      label: "Professoressa, è già stata a un nostro Convegno?",
      value: "f",
    },
    {
      label: "Professore, è già stato a un nostro Convegno?",
      value: "m",
    },
    {
      label: "Prof., è già stat* a un nostro Convegno?",
      value: "u",
    },
  ],
  ROLE_PARENT: [
    {
      label: "Ciao, sei riuscita ad attivare il libro digitale?",
      value: "f",
    },
    {
      label: "Ciao, sei riuscito ad attivare il libro digitale?",
      value: "m",
    },
    {
      label: "Ciao, sei riuscit* ad attivare il libro digitale?",
      value: "u",
    },
  ],
  // FIXME: Check those strings
  ROLE_PRINCIPAL: [
    {
      label: "Professoressa, è già stata a un nostro Convegno?",
      value: "f",
    },
    {
      label: "Professore, è già stato a un nostro Convegno?",
      value: "m",
    },
    {
      label: "Prof., è già stat* a un nostro Convegno?",
      value: "u",
    },
  ],
  ROLE_STUDENT: [
    {
      label: "Ciao, sei riuscita ad attivare il libro digitale?",
      value: "f",
    },
    {
      label: "Ciao, sei riuscito ad attivare il libro digitale?",
      value: "m",
    },
    {
      label: "Ciao, sei riuscit* ad attivare il libro digitale?",
      value: "u",
    },
  ],
  ROLE_TEACHER: [
    {
      label: "Professoressa, è già stata a un nostro Convegno?",
      value: "f",
    },
    {
      label: "Professore, è già stato a un nostro Convegno?",
      value: "m",
    },
    {
      label: "Prof., è già stat* a un nostro Convegno?",
      value: "u",
    },
  ],
};
